import axios from 'axios';

class CompanyService {

    async insert(data) {
        return axios.post(
            process.env.REACT_APP_API_HOST + `/company/insert`,
            data
        ).catch(function(error) {
            console.log(error);
        })
    }

    async update(data) {
        return axios.post(process.env.REACT_APP_API_HOST + "/company/update", data)
            .then((response) => {
                return response;
            }).catch((error) => {
                return error.response;
            });
    }

    async delete(data) {
        return axios.post(process.env.REACT_APP_API_HOST + "/company/delete", data)
            .then((response) => {
                return response;
            }).catch((error) => {
                return error.response;
            });
    }

    async getCompanyDocumentById(id) {
        return axios.get(
            process.env.REACT_APP_API_HOST + `/company/getCompanyDocumentById/${id}`,
        ).catch(function(error) {
            console.log(error);
        })
    }

    async getCompanyById(id) {
        return axios.get(
            process.env.REACT_APP_API_HOST + `/company/${id}`,
        ).catch(function(error) {
            console.log(error);
        })
    }

    async getCompanyAll() {
        return await axios.get(
            process.env.REACT_APP_API_HOST + '/company/',
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async getCompanyMTESS(mtess) {
        return await axios.get(
            process.env.REACT_APP_API_HOST + '/company/mtess/' + mtess,
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }

    async getAllPatronal() {
        return await axios.get(
            process.env.REACT_APP_API_HOST + "/patronal/", {
                headers: { "content-type": "application/x-www-form-urlencoded" }
            }
        ).then((response) => {
            return response;
        }).catch((error) => {
            return error.response;
        });
    }
}

const instance = new CompanyService();

export default instance;